import { render, staticRenderFns } from "./personalRules.vue?vue&type=template&id=d770838a&scoped=true&"
import script from "./personalRules.vue?vue&type=script&lang=js&"
export * from "./personalRules.vue?vue&type=script&lang=js&"
import style0 from "./personalRules.vue?vue&type=style&index=0&id=d770838a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d770838a",
  null
  
)

export default component.exports